import React from "react";
import { Link } from "react-router-dom";
import "./AdPerformanceDashboards.css";

const cards = [
  {
    section: "Google Ads",
    logo: "google",
    badge: null,
    items: [
      {
        title: "Campaigns Dashboard",
        body:
          "Campaign and PMAX asset group performance across all accounts. Includes leads, calls, CPL, and creative thumbnails.",
        href: "/marketing-reports/campaigns-dashboard",
        cta: "Open dashboard ->",
        comingSoon: false,
      },
      {
        title: "MTD Performance",
        body:
          "Month-to-date performance vs goals. Tracks budget pacing, leads %, CPL vs goal, and calls across OEM and Used divisions.",
        href: "/marketing-reports/mtd-performance",
        cta: "Open dashboard ->",
        comingSoon: false,
      },
    ],
  },
  {
    section: "Meta Ads",
    logo: "meta",
    badge: null,
    items: [
      {
        title: "Campaign Dashboard",
        body:
          "Meta campaign and ad set performance across all accounts.",
        href: "/marketing-reports/meta-campaign-dashboard",
        cta: "Open dashboard ->",
        comingSoon: false,
      },
      {
        title: "MTD Performance",
        body:
          "Month-to-date Meta performance vs goals and budget pacing.",
        href: "/marketing-reports/meta-mtd",
        cta: "Open dashboard ->",
        comingSoon: false,
      },
    ],
  },
  {
    section: "Cross-Channel",
    logo: "cross",
    badge: null,
    items: [
      {
        title: "Consolidated MTD Performance",
        body:
          "Cross-channel month-to-date performance combining Google Ads and Meta. Budget pacing, leads, CPL, and channel breakdown.",
        href: "/marketing-reports/consolidated-mtd",
        cta: "Open dashboard ->",
        comingSoon: false
      },
      {
        title: "Paid Media Combined Performance",
        body:
          "CPL trends (Dec-Mar), MoM change, leads goal vs projected, and CPL by dealership - Google + Meta combined.",
        href: "/marketing-reports/combined-performance",
        cta: "Open dashboard ->",
        comingSoon: false
      }
    ]
  }
];

const GoogleAdsLogo = () => (
  <svg
    className="adp-logo"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10.2 5.2C11.2 3.4 13.6 2.9 15.4 3.9C17.2 4.9 17.8 7.2 16.8 9L9.7 21.6C8.7 23.4 6.4 24 4.6 23C2.8 22 2.2 19.7 3.2 17.9L10.2 5.2Z"
      fill="#34A853"
    />
    <path
      d="M17.4 6.7C18.4 4.9 20.7 4.3 22.5 5.3C24.3 6.3 24.9 8.6 23.9 10.4L16.8 23C15.8 24.8 13.5 25.4 11.7 24.4C9.9 23.4 9.3 21.1 10.3 19.3L17.4 6.7Z"
      fill="#FBBC05"
    />
    <circle cx="6.2" cy="21.2" r="3.2" fill="#4285F4" />
  </svg>
);

const MetaLogo = () => (
  <svg
    className="adp-logo"
    width="30"
    height="20"
    viewBox="0 0 30 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M9.6 18.2C6.8 18.2 4.5 15.5 3.2 12.8C1.9 10 1.4 7.1 1.7 5.2C2 3.1 3.1 2 4.7 2C6.6 2 8.5 3.9 10.6 7.4L12.4 10.5L14.3 7.2C16.3 3.8 18.1 2 20 2C21.6 2 22.7 3.1 23 5.2C23.3 7.1 22.8 10 21.5 12.8C20.2 15.5 17.9 18.2 15.1 18.2C13.6 18.2 12.4 17.5 10.9 15.5L12.4 12.9C13.6 14.5 14.4 15.1 15.1 15.1C16.7 15.1 18.4 13 19.4 10.8C20.4 8.6 20.8 6.3 20.6 5.4C20.5 4.6 20.2 4.5 20 4.5C19.3 4.5 18.1 5.6 16.3 8.7L12.4 15.3L8.4 8.6C6.6 5.6 5.4 4.5 4.7 4.5C4.5 4.5 4.2 4.6 4.1 5.4C3.9 6.3 4.3 8.6 5.3 10.8C6.3 13 8 15.1 9.6 15.1C10.3 15.1 11.1 14.5 12.4 12.9L13.9 15.5C12.4 17.5 11.1 18.2 9.6 18.2Z"
      fill="#0064E0"
    />
  </svg>
);

const CardIcon = () => (
  <svg
    className="adp-card-icon"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="1" y="1" width="20" height="20" rx="6" fill="#FFF3E5" />
    <path
      d="M6 14L10 10L13 12L17 8"
      stroke="#FF8A1C"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CrossChannelLogo = () => (
  <svg
    className="adp-logo"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="3" y="4" width="8" height="8" rx="2" fill="#1DA1F2" />
    <rect x="15" y="4" width="8" height="8" rx="2" fill="#FF8A1C" />
    <rect x="3" y="14" width="8" height="8" rx="2" fill="#34A853" />
    <rect x="15" y="14" width="8" height="8" rx="2" fill="#8A62D6" />
  </svg>
);

export default function AdPerformanceDashboards() {
  return (
    <div className="adp-page">
      <header className="adp-hero">
        <div className="adp-hero-inner">
          <p className="adp-kicker">FFUN - Ad Performance Dashboards</p>
          <p className="adp-subtitle">
            Internal reporting hub - Auto-updated daily at 7 AM
          </p>
        </div>
      </header>

      <main className="adp-main">
        <div className="adp-breadcrumb">
          <span>Marketing Dashboards</span>
          <span className="adp-dot">-</span>
          <span>Ad Performance</span>
        </div>

        {cards.map((group) => (
          <section className="adp-section" key={group.section}>
            <div className="adp-section-header">
              <div className="adp-section-title">
                {group.logo === "google" ? (
                  <GoogleAdsLogo />
                ) : group.logo === "meta" ? (
                  <MetaLogo />
                ) : (
                  <CrossChannelLogo />
                )}
                <h2>{group.section}</h2>
              </div>
              {group.badge && <span className="adp-badge">{group.badge}</span>}
            </div>

            <div className="adp-cards">
              {group.items.map((item) => (
                <div
                  className={`adp-card ${item.comingSoon ? "adp-card--muted" : ""}`}
                  key={item.title}
                >
                  <div className="adp-card-top">
                    <CardIcon />
                    <h3>{item.title}</h3>
                  </div>
                  <p className="adp-card-body">{item.body}</p>
                  {item.comingSoon ? (
                    <span className="adp-cta adp-cta--disabled">{item.cta}</span>
                  ) : (
                    <Link className="adp-cta" to={item.href}>
                      {item.cta}
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}
